export const covertValueTypeToKey = (valueType: string) => {
  return `value${valueType.charAt(0)}${valueType.slice(1).toLowerCase()}`;
};

export const normalizeBuildValue = (
  value: string | null,
  of?: {
    prefix?: string;
    nilLabel?: string;
    unit?: number;
  },
) => {
  if (value === null) return of.nilLabel;

  if (of.unit) return `${value} ${of.unit}`;

  if (of.prefix) return `${of.prefix}${value}`;

  return value;
};
